module.exports = __webpack_public_path__ + "img/GHB.f867387d.png";